export interface RecoveryCodesStatus {
  recoveryCodesSavedAt: string | null;
}
export async function readRecoveryCodesStatus(): Promise<RecoveryCodesStatus> {
  const response = await fetch('/api/access/recovery-codes/status', { credentials: 'same-origin', cache: 'no-store' });
  if (!response.ok) throw new Error('Recovery status unavailable');
  return response.json();
}
export async function acknowledgeRecoveryCodes(code: string): Promise<string> {
  const response = await fetch('/api/access/recovery-codes/acknowledge', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }),
  });
  if (!response.ok) throw new Error('Recovery acknowledgement unavailable');
  const data = await response.json();
  if (!data.recoveryCodesSavedAt) throw new Error('Recovery acknowledgement missing');
  return data.recoveryCodesSavedAt;
}
export function formatRecoverySavedAt(value: string, language: string) {
  return new Intl.DateTimeFormat(language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}
